// extracted by mini-css-extract-plugin
export default {"footerSubtext":"AddRecipientModal__footerSubtext___FdMwV","footerButtonWrapper":"AddRecipientModal__footerButtonWrapper___s9o8l"};